// Third Party Imports
import {setContext} from 'apollo-link-context';

// Relative Imports
import {CSRF_HEADER_NAME} from './ajaxHelper';
import getCsrfToken from './csrfTokenHelper';

/**
 * Intended for browser use only - server can pluck CSRF token from plugin
 * directly. Awaits the csrf token fetched from the server, merges it in to the
 * request headers
 */
const setCsrfTokenLink = setContext(async (request, prevContext) => ({
    headers: {...prevContext.headers, [CSRF_HEADER_NAME]: await getCsrfToken()}
}));

export default setCsrfTokenLink;
